import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import ProChioseTree from "@/components/pro-common/pro-chiose-modal/pro-chiose-tree.vue";
export default {
  name: "pro-chiose-tab-departmemt",
  components: {
    ProChioseTree
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    _treeData() {
      let treeData = JSON.parse(JSON.stringify(this.treeData));
      this.DG(treeData, true);
      return treeData;
    }
  },
  methods: {
    DG(treeData, boo) {
      treeData.forEach(v => {
        if (boo) {
          v.isCheckDisabled = true;
        }
        v.expand = boo || false;
        v.disabled = true;
        if (v.children && v.children.length > 0) {
          this.DG(v.children);
        }
      });
    },
    onChange(item) {
      let checkedList = [...this.value];
      if (item.isCheck) {
        checkedList.unshift(item);
      } else {
        checkedList = checkedList.filter(v => v.orgId !== item.orgId);
      }
      this.$emit("input", checkedList);
    }
  }
};